<!-- ----------------------------------------------- -->
<template>
  <nav id="map-mb-header" :class="getBackgroundColor">
    <v-row align="center" class="map-header pa-0 ml-1">
      <v-tooltip right v-if="!isReduction">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            @click="showAreaSearch"
            :disabled="disableAreaSearch"
            v-on="on"
          >
            <v-icon :class="getTextColor">search</v-icon>
          </v-btn>
        </template>
        <span>{{ text.search }}</span>
      </v-tooltip>
      <span :class="getTextColor">{{ dispCenterTwon }}</span>
      <v-spacer></v-spacer>
      <map-past-popup v-show="!isCurrent" class="mr-4"></map-past-popup>
      <v-tooltip left v-if="!isReduction">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            class="mr-4"
            @click="showCalendar"
            :disabled="disableCalendar"
            v-on="on"
          >
            <v-icon :class="getTextColor">calendar_today</v-icon>
          </v-btn>
        </template>
        <span>{{ text.calendar }}</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            small
            depressed
            outlined
            :class="getTextColor"
            @click="showMbSideMenu"
            :disabled="disableMbSideMenu"
            v-on="on"
            class="mr-4"
          >
            <v-icon :class="getTextColor" v-if="isMbSideMenu"
              >visibility</v-icon
            >
            <v-icon :class="getTextColor" v-if="!isMbSideMenu"
              >visibility_off</v-icon
            >
          </v-btn>
        </template>
        <span>{{ text.sideMenu }}</span>
      </v-tooltip>
    </v-row>
  </nav>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 モバイル用地図ヘッダ
 * MapHeader.vue
 * @author LIS
 */
import mixin from "./../../lib/mixin.js";
import MapPastPopup from "../../components/map/PastPopup.vue";

export default {
  /** タグ名 */
  name: "map-mb-header",
  mixins: [mixin],
  components: {
    MapPastPopup
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        search: "市町村名検索",
        calendar: "過去日付選択",
        sideMenu: "サイドメニュー表示切替",
      },
    };
  },
  computed: {
    /** 地図位置名 */
    cityName: {
      get() {
        var pref = this.$store.state.map.prefName;
        var town = this.$store.state.map.townName;
        return pref + town;
      },
    },
    /** 履歴表示 */
    isCurrent: {
      get() {
        return this.$store.state.app.isCurrent;
      },
    },
    /** 表示コンテンツ取得 */
    getContent: {
      get() {
        return this.$store.state.app.content;
      },
    },
    /** 履歴表示有無により背景色を判断する */
    getBackgroundColor: {
      get() {
        if (this.$store.state.app.isCurrent) {
          return "secondary";
        }
        return "brown lighten-3";
      },
    },
    /** 履歴表示有無により文字とアイコン色を判断する */
    getTextColor: {
      get() {
        if (this.$store.state.app.isCurrent) {
          return "success--text";
        }
        return "brown--text";
      },
    },
    /** モバイルメニュー表示状態 */
    isMbSideMenu: {
      get() {
        return this.$store.state.map.showMbSideMenu;
      },
    },
    /** 検索ボタンの活性/非活性を制御する */
    disableAreaSearch: {
      get() {
        return !this.$store.getters["radar/isNotPlay"];
      },
    },
    /** モバイルメニューの活性/非活性を制御する */
    disableMbSideMenu: {
      get() {
        return !this.$store.getters["radar/isNotPlay"];
      },
    },
    /** カレンダーの活性/非活性を制御する */
    disableCalendar: {
      get() {
        // 履歴動画再生状態による制御
        if (!this.$store.getters["radar/isNotPlay"] || !this.$store.getters["Telemeter/isNotPlayMb"]) {
          return true;
        }

        // 表示コンテンツによる制御
        if (
          this.getContent == "Inundation" ||
          this.getContent == "VcPoint" ||
          this.getContent == "VcDefault" ||
          this.getContent == "VcCustom"
        ) {
          return true;
        }
        return false;
      },
    },
    /** 簡易版の判定 */
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
    /** 表示中心市町村設定 */
    dispCenterTwon: {
      get() {
        if (
          this.$store.state.map.zoom >= this.$store.state.map.mapConfig.zoomCity
        ) {
          return this.$store.state.map.dispCenterTwon;
        } else {
          let pref = this.$store.state.map.prefName;
          let town = this.$store.state.map.townName;
          return pref + town;
        }
      },
    },
  },
  methods: {
    /** 住所検索ダイアログの表示/非表示 */
    showAreaSearch() {
      if (!this.$store.state.map.showAreaSearch) {
        // 地図上のダイアログを全て非表示
        this.$store.commit("map/dialogAllClose");
        // モバイルモード初期表示(全てのダイアログを非表示)
        this.routerPush("/mb");
        this.$store.commit("app/setContent", "");
      }
      this.$store.commit(
        "map/setShowAreaSearch",
        !this.$store.state.map.showAreaSearch
      );
    },
    /** 観測日時指定ダイアログの表示/非表示 */
    showCalendar() {
      if (!this.$store.state.map.showCalendar) {
        // 地図上のダイアログを全て非表示
        this.$store.commit("map/dialogAllClose");
        // モバイルモード初期表示(全てのダイアログを非表示)
        this.routerPush("/mb");
        this.$store.commit("app/setContent", "");
      }
      this.$store.commit(
        "map/setShowCalendar",
        !this.$store.state.map.showCalendar
      );
    },
    /** モバイルメニュー表示切替 */
    showMbSideMenu() {
      this.$store.commit("map/toggleShowMbSideMenu");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
#map-mb-header {
  z-index: 3000;
  width: 100%;
  height: 34px;
  .map-header {
    width: 100%;
    height: 100%;
    font-size: 0.8rem;
  }
  .map-menu-btn {
    width: 72px;
  }
}
</style>
